
// PRODUCT
export const STATUS_NOT_CONFIRMED       = 0;
export const STATUS_CONFIRMED           = 1;
export const STATUS_CANCELED            = 4;
export const STATUS_PAID                = 5;

// SYSTEM
export const SYS_VERSION                = "ALPHA 0.0.38"
export const SYS_BASE_URL               = "https://dash.pedidorapido.app/"